<template>
  <ul class="a-vdxb-caption-list">
    <slot></slot>
  </ul>
</template>

<script>
export default {
  name: 'a-vdxb-caption-list',
  props: {
    list: {
      type: Array,
      default: null,
    },
  },
};
</script>
